// extracted by mini-css-extract-plugin
module.exports = {"divider":"CustomSplitter_divider__2ULQc","root":"CustomSplitter_root__1BBB1","panel":"CustomSplitter_panel__3OaRs"};